import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import { BsToggles } from "react-icons/bs";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import config from "../../../../config/config";
import {
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  ERROR_EXISTS,
} from "../../../../common/Constant";
import { toastError, toastSuccess } from "../../../../common/Toast";

let allData = [];
const Items = (props) => {
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  const paramObject = useParams();
  const [formValues, setFormValues] = useState({
    AddItem: "",
  });
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statenew, setStateNew] = useState([]);
  const [items, setItems] = useState([]);
  const [filteredItemKits, setFilteredItemKits] = useState([]);
  const callback = (payload) => {
    console.log("payload =>", payload);

    if (payload != undefined) {
      const newItem = payload;
      const existingItemIndex = statenew.findIndex(
        (item) => item.VariationId === newItem.VariationId
      );
      if (existingItemIndex == -1) {
        setStateNew([...statenew, payload]);
        if (allData.length > 0) {
          allData = [...allData, { payload }];
        } else {
          allData = [{ payload }];
        }
        // allData = [...allData, { payload }];
      }

      // setStateNew([...statenew, payload[0]]);
    }
  };

  // For handling the Quantity Change
  const handleQuantityChange = (index, value) => {
    console.log(index, value);
    const updatedData = [...statenew];
    updatedData[index] = { ...updatedData[index], itemquantity: Number(value) };
    console.log("updatedData ==> ", updatedData);
    setStateNew(updatedData);
  };

  // For handling item deletion
  const handleDeleteItem = (itemId) => {
    const index = statenew.findIndex((item) => item.ItemName === itemId);
    if (index !== -1) {
      setStateNew((prevState) => {
        const newState = [...prevState];
        newState.splice(index, 1);
        return newState;
      });
    }
  };

  //items upsert
  const handleSubmit = () => {
    console.log("statenew ==> ", statenew);

    let updatedItems = [];

    for (let i = 0; i < statenew.length; i++) {
      console.log(i, statenew[i].ItemId);
      if (statenew[i].ItemId > 0) {
        console.log("statenew ::::::: ===> ", statenew[i]);
        updatedItems.push(statenew[i]);
      }
    }

    console.log("updatedItems ==> ", updatedItems);

    const filteredItemKits = updatedItems.filter(
      (element) => element !== undefined
    );
    console.log("filteredItemKits ==> ", filteredItemKits);

    let ItemKitsData = filteredItemKits.filter(function (item) {
      return item.ItemId !== 0;
    });

    // Use only the required properties in the output object
    const ItemKitsobj = {
      itemkitsxml: ItemKitsData.map(function (item) {
        return {
          id: 0,
          itemid: item.ItemId,
          quantity: item.itemquantity,
          itemvariationid: item.VariationId,
        };
      }),
    };

    let itemkitsjsonstring = JSON.stringify(ItemKitsobj);
    console.log("itemkitsjsonstring: ", itemkitsjsonstring);

    const postingdata = {
      itemkitsinsertxml: itemkitsjsonstring,
      itemkitid: paramObject.id || 0,
      loginuserid: loginUserId,
    };

    console.log("postingdata: ", postingdata);

    axios
      .post(`${config.itemKitsBaseUrl}/itemkits/itemsupsert`, postingdata, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          // setItems(updatedItems);
          // setFilteredItemKits(filteredItemKits);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      });
  };

  //items binding
  useEffect(() => {
    console.log(paramObject.id);
    if (paramObject.id > 0) {
      axios
        .get(
          `${config.itemKitsBaseUrl}/itemkits/itemsfindbyid?id=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log(res.data.ResponseData.Itemkitsimages);
          if (res.data.ResponseCode === "SUCCESS") {
            // Update the state with the retrieved item kit data
            console.log(res.data.ResponseData.Itemkitsimages);
            setStateNew(res.data.ResponseData.Itemkitsimages);
          } else {
            toastError(ERROR_MESSAGE);
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    }
  }, []);

  const ActionButtons = (props) => {};
  const handleBack = () => {
    props.previousStep();
    window.scrollTo(0, 0);
  };

  const handleNext = () => {
    props.nextStep();
    window.scrollTo(0, 0);
  };

  const handleCombinedChange = () => {
    handleSubmit();
    handleNext();
  };

  return (
    <>
      <div className="card ">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="card-title">
            <BsToggles className="me-1" />
            Items Added
          </h5>
          <div>
            {props.currentStep > 1 && (
              <button
                onClick={handleBack}
                className="btn btn-primary btn-md me-1"
              >
                Back
              </button>
            )}
            {props.currentStep < props.totalSteps && (
              <button
                onClick={handleCombinedChange}
                className="btn btn-primary btn-md"
                type="submit"
              >
                Next
              </button>
            )}
          </div>
        </div>
      </div>

      <Formik
        {...props}
        initialValues={formValues}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ errors, touched, handleChange }) => (
          <div className="row mb-3">
            <div className="col-md-2 mb-3 mt-2 align-center">
              <label className="form-label" style={{ marginTop: "30px" }}>
                Add Item
              </label>
            </div>

            <div className="col-md-10 mb-3">
              <p>
                Item Kits are made up of 1 or more items to see as a group. Add
                your first item using the below field.
              </p>
              <div className="col-md-8 ">
                <SearchableDropdown callback={callback} options={options} />
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover table-bordered table-condensed">
                <thead>
                  <tr>
                    <th>Delete</th>
                    <th>ItemName</th>
                    <th>Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {statenew.map((item, index) => (
                    <tr key={item.itemId}>
                      <td>
                        <Link
                          className="confirm-text"
                          title="Delete"
                          style={{ fontSize: "12px" }}
                          onClick={() => handleDeleteItem(item.ItemName)}
                        >
                          <i
                            className="fa fa-trash text-red fa-2x"
                            data-bs-toggle="tooltip"
                            title="Delete"
                          ></i>
                        </Link>
                      </td>
                      <td>{item.ItemName}</td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          value={parseFloat(item.itemquantity)}
                          onChange={(e) =>
                            handleQuantityChange(index, e.target.value)
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="text-center mt-5">
              {props.currentStep > 1 && (
                <button onClick={handleBack} className="btn btn-primary me-3">
                  Back
                </button>
              )}
              {props.currentStep < props.totalSteps && (
                <button
                  onClick={handleCombinedChange}
                  className="btn btn-primary"
                  type="submit"
                >
                  Next
                </button>
              )}
            </div>
          </div>
        )}
      </Formik>
      <ActionButtons {...props} />
    </>
  );
};

const SearchableDropdown = ({ callback }) => {
  const token = localStorage.getItem("Token");
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    // Fetch data from an API
    const fetchData = async () => {
      if (inputValue != "") {
        axios
          .get(
            `${config.itemsBaseUrl}/items/search?searchparam=${inputValue}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            }
          )
          .then((response) => {
            if (response != "" && response != null) {
              console.log("response =>", response.data.ResponseData);
              const data = response.data.ResponseData;
              if (data[0].ItemId > 0) {
                setSuggestions(data);
                console.log("suggestion", data);
              } else {
                setSuggestions([]);
              }
            }
          })
          .catch((error) => {});
      } else {
        setSuggestions([]);
      }
    };

    fetchData();
  }, [inputValue]);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);

    if (!value) {
      setSuggestions([]);
    }
  };

  const handleInputClick = (
    pItemId,
    pItemName,
    pVariationName,
    pVariationId,
    pUnitPrice,
    //pitemquantity,
    pCategoryName,
    pDescription,
    pAttributeId
  ) => {
    console.log(pItemName);
    const selectedOption = {
      ItemId: pItemId,
      UnitPrice: pUnitPrice,
      ItemName: pItemName,
      VariationName: pVariationName,
      VariationId: pVariationId,
      itemquantity: 1,
      Description: pDescription,
      CategoryName: pCategoryName,
      AttributeId: pAttributeId,
    };

    console.log("selectedOption =>", selectedOption);
    // setTableData([...tableData, selectedOption]);
    setTableData(selectedOption);

    setInputValue("");
    setSuggestions([]);
  };

  useEffect(() => {
    // const locationItemData = tableData.filter((locationItem) => {
    //   return locationItem.ItemId !== "";
    // });
    // const locationItemData = tableData;
    console.log("locationItemData ===>", tableData);
    callback(tableData);
  }, [tableData]);

  return (
    <div className="container">
      <form>
        <div className="mb-3">
          <div class="input-group flex-nowrap">
            <span class="input-group-text" id="addon-wrapping">
              <a href="google.com">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-pencil-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                  <path
                    fill-rule="evenodd"
                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                  />
                </svg>
              </a>
            </span>

            <input
              type="text"
              class="form-control"
              placeholder="Type item name or scan barcode"
              value={inputValue}
              onChange={handleInputChange}
            />
          </div>
        </div>
        {suggestions.length > 0 ? (
          <div className="dropdown">
            <ul className="dropdown-menu w-100 show">
              {suggestions.map((item) => (
                <li
                  key={item.ItemId}
                  onClick={(e) =>
                    handleInputClick(
                      item.ItemId,
                      item.ItemName,
                      item.VariationName,
                      item.VariationId,
                      item.UnitPrice,
                      item.itemquantity,
                      item.Description,
                      item.AttributeId,
                      item.CategoryName
                    )
                  }
                >
                  {item && (
                    <a
                      key={item.ItemId}
                      className="dropdown-item"
                      data-name={item.ItemName?.toLowerCase()}
                    >
                      <img
                        src={item.ImageName}
                        onError={(e) => {
                          e.currentTarget.src =
                            "https://th.bing.com/th/id/OIP.ADcGkW6WTfq2zu8yoY8vlgHaHa?w=197&h=197&c=7&r=0&o=5&pid=1.7";
                        }}
                        alt={item.ItemName}
                        className="img-thumbnail rounded-circle mr-5"
                        width="65px"
                        height="65px"
                      />
                      <div className="customer-info">
                        <h6 className="name">{item.ItemName}</h6>
                        <div>
                          Cost Price: {parseFloat(item.CostPrice).toFixed(2)} |
                          Promo Price: {parseFloat(item.PromoPrice).toFixed(2)}{" "}
                          | Unit Price: {parseFloat(item.UnitPrice).toFixed(2)}
                        </div>
                        <div>
                          Qty: {parseInt(item.itemquantity)} | Category:{" "}
                          {item.CategoryName}
                        </div>
                      </div>
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ) : (
          ""
        )}
      </form>
    </div>
  );
};

export default Items;
